export const messages = {
  en: {
    payFeeQrcode: {
      search: {
        title: 'Search Condition',
        qrcodeName: 'QR Code Name'
      },
      list: {
        title: 'Payment QR Code List'
      },
      table: {
        qrcodeName: 'Name',
        queryWay: 'Query Method',
        smsValidate: 'Validation',
        customFee: 'Custom Payment',
        feeType: 'Display Fee',
        state: 'Status',
        createStaffName: 'Creator',
        createTime: 'Create Time'
      },
      queryWay: {
        byPhone: 'By Owner Phone',
        byHouse: 'By House',
        byBoth: 'By House or Owner Phone'
      },
      feeType: {
        owner: 'Owner Fee',
        house: 'House Fee'
      },
      operation: {
        viewQrcode: 'QR Code'
      },
      form: {
        qrcodeName: 'Name',
        queryWay: 'Query Method',
        smsValidate: 'Validation',
        customFee: 'Custom Payment',
        preFee: 'Prepayment',
        content: 'Prompt Content'
      },
      placeholder: {
        qrcodeName: 'Please enter name',
        queryWay: 'Please select query method',
        smsValidate: 'Please select validation',
        customFee: 'Please select custom payment',
        preFee: 'Please select prepayment',
        content: 'Please enter prompt content'
      },
      rules: {
        qrcodeName: 'Name cannot be empty',
        qrcodeNameMax: 'Name cannot exceed 128 characters',
        queryWay: 'Please select query method',
        smsValidate: 'Please select validation',
        customFee: 'Please select custom payment',
        preFee: 'Please select prepayment',
        content: 'Prompt content cannot be empty',
        contentMax: 'Prompt content cannot exceed 512 characters',
        pfqId: 'ID cannot be empty'
      },
      add: {
        title: 'Add Payment QR Code'
      },
      edit: {
        title: 'Edit Payment QR Code'
      },
      delete: {
        title: 'Delete Confirmation',
        confirmText: 'Are you sure to delete this payment QR code?'
      },
      view: {
        title: 'Payment QR Code',
        tip: 'Please take a screenshot and post it at the cashier',
        miniQrcode: 'Mini Program QR Code',
        publicQrcode: 'Official Account QR Code',
        miniTip: 'Scan with WeChat to pay in Mini Program',
        publicTip: 'Scan with WeChat to pay in Official Account',
        noQrcode: 'No QR Code'
      },
      message: {
        addSuccess: 'Added successfully',
        addFailed: 'Failed to add',
        editSuccess: 'Modified successfully',
        editFailed: 'Failed to modify',
        deleteSuccess: 'Deleted successfully',
        deleteFailed: 'Failed to delete',
        fetchError: 'Failed to get data'
      }
    }
  },
  zh: {
    payFeeQrcode: {
      search: {
        title: '查询条件',
        qrcodeName: '二维码名称'
      },
      list: {
        title: '支付二维码列表'
      },
      table: {
        qrcodeName: '名称',
        queryWay: '查询方式',
        smsValidate: '验证',
        customFee: '自定义缴费',
        feeType: '展示费用',
        state: '状态',
        createStaffName: '创建人',
        createTime: '创建时间'
      },
      queryWay: {
        byPhone: '按业主手机号',
        byHouse: '按房屋',
        byBoth: '按房屋或者业主手机号'
      },
      feeType: {
        owner: '业主费用',
        house: '房屋费用'
      },
      operation: {
        viewQrcode: '二维码'
      },
      form: {
        qrcodeName: '名称',
        queryWay: '查询方式',
        smsValidate: '验证',
        customFee: '自定义缴费',
        preFee: '预交费',
        content: '提示内容'
      },
      placeholder: {
        qrcodeName: '请输入名称',
        queryWay: '请选择查询方式',
        smsValidate: '请选择验证',
        customFee: '请选择自定义缴费',
        preFee: '请选择预交费',
        content: '请输入提示内容'
      },
      rules: {
        qrcodeName: '名称不能为空',
        qrcodeNameMax: '名称不能超过128个字符',
        queryWay: '请选择查询方式',
        smsValidate: '请选择验证',
        customFee: '请选择自定义缴费',
        preFee: '请选择预交费',
        content: '提示内容不能为空',
        contentMax: '提示内容不能超过512个字符',
        pfqId: '编号不能为空'
      },
      add: {
        title: '添加支付二维码'
      },
      edit: {
        title: '修改支付二维码'
      },
      delete: {
        title: '删除确认',
        confirmText: '确定删除该支付二维码吗？'
      },
      view: {
        title: '支付二维码',
        tip: '请截图贴在收银台',
        miniQrcode: '小程序二维码',
        publicQrcode: '公众号二维码',
        miniTip: '微信扫码打开小程序缴费',
        publicTip: '微信扫码打开公众号缴费',
        noQrcode: '暂无二维码'
      },
      message: {
        addSuccess: '添加成功',
        addFailed: '添加失败',
        editSuccess: '修改成功',
        editFailed: '修改失败',
        deleteSuccess: '删除成功',
        deleteFailed: '删除失败',
        fetchError: '获取数据失败'
      }
}
  },
  'zh-TW': {
    payFeeQrcode: {
      search: {
        title: '查詢條件',
        qrcodeName: '二維碼名稱'
      },
      list: {
        title: '支付二維碼列表'
      },
      table: {
        qrcodeName: '名稱',
        queryWay: '查詢方式',
        smsValidate: '驗證',
        customFee: '自定義繳費',
        feeType: '展示費用',
        state: '狀態',
        createStaffName: '創建人',
        createTime: '創建時間'
      },
      queryWay: {
        byPhone: '按業主手機號',
        byHouse: '按房屋',
        byBoth: '按房屋或者業主手機號'
      },
      feeType: {
        owner: '業主費用',
        house: '房屋費用'
      },
      operation: {
        viewQrcode: '二維碼'
      },
      form: {
        qrcodeName: '名稱',
        queryWay: '查詢方式',
        smsValidate: '驗證',
        customFee: '自定義繳費',
        preFee: '預交費',
        content: '提示內容'
      },
      placeholder: {
        qrcodeName: '請輸入名稱',
        queryWay: '請選擇查詢方式',
        smsValidate: '請選擇驗證',
        customFee: '請選擇自定義繳費',
        preFee: '請選擇預交費',
        content: '請輸入提示內容'
      },
      rules: {
        qrcodeName: '名稱不能為空',
        qrcodeNameMax: '名稱不能超過128個字元',
        queryWay: '請選擇查詢方式',
        smsValidate: '請選擇驗證',
        customFee: '請選擇自定義繳費',
        preFee: '請選擇預交費',
        content: '提示內容不能為空',
        contentMax: '提示內容不能超過512個字元',
        pfqId: '編號不能為空'
      },
      add: {
        title: '添加支付二維碼'
      },
      edit: {
        title: '修改支付二維碼'
      },
      delete: {
        title: '刪除確認',
        confirmText: '確定刪除該支付二維碼嗎？'
      },
      view: {
        title: '支付二維碼',
        tip: '請截圖貼在收銀台',
        miniQrcode: '小程序二維碼',
        publicQrcode: '公眾號二維碼',
        miniTip: '微信掃碼打開小程序繳費',
        publicTip: '微信掃碼打開公眾號繳費',
        noQrcode: '暫無二維碼'
      },
      message: {
        addSuccess: '添加成功',
        addFailed: '添加失敗',
        editSuccess: '修改成功',
        editFailed: '修改失敗',
        deleteSuccess: '刪除成功',
        deleteFailed: '刪除失敗',
        fetchError: '獲取數據失敗'
      }
    }
  }
}